import { Box, Typography, Tooltip } from '@mui/material';
import { memo } from 'react';
import { ServiceIcon } from './ServiceIcon';
import { StatusIcon } from './StatusIcon';

const categoryTranslations = {
  HandBaggage: 'Equipaje de mano',
  Baggage: 'Equipaje de bodega',
  SeatMap: 'Asiento asignado',
  Changes: 'Cambios de ticket',
  Refund: 'Reembolso',
};

const statuses = [
  { label: 'Incluido', indicator: 'INC' },
  { label: 'Con cargos', indicator: 'CHA' },
  { label: 'Según el segmento', indicator: 'MIX' },
  { label: 'No incluido', indicator: 'NOF' },
];

const getStatusLabel = (indicator) => {
  const status = statuses.find((s) => s.indicator === indicator);
  return status ? status.label : 'Sin información';
};

const JourneyStatus = memo(({ journey, status }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', my: 0.5 }}>
    <StatusIcon indicator={status} />
    <Typography color='#000' marginLeft={1} variant='body2'>
      {journey}
    </Typography>
    <Typography color='#666' variant='body2'>
      : {getStatusLabel(status)}
    </Typography>
  </Box>
));

export const ServiceItem = memo(({ service, journeys }) => {
  const renderStatusIcon = (service) => {
    if (service.indicator === 'MIX') {
      const tooltipContent = (
        <Box className='tooltip-total-container' sx={{ p: 1 }}>
          {journeys.map((journey, index) => (
            <JourneyStatus journey={journey} key={journey} status={service.journeys[index]} />
          ))}
        </Box>
      );

      return (
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: 'transparent !important',
                maxWidth: 'max-content',
              },
            },
          }}
          placement='left'
          title={tooltipContent}
        >
          <Box component='span'>
            <StatusIcon indicator={service.indicator} />
          </Box>
        </Tooltip>
      );
    }

    return <StatusIcon indicator={service.indicator} />;
  };

  if (!categoryTranslations.hasOwnProperty(service.category)) return null;

  const categoryIndex = Object.keys(categoryTranslations).indexOf(service.category);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        order: categoryIndex,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ServiceIcon category={service.category} />
        <Typography variant='body2'>{categoryTranslations[service.category]}</Typography>
      </Box>
      {renderStatusIcon(service)}
    </Box>
  );
});
